import useNumberFormatter from "@/hooks/useNumberFormatter";
import { Card, HStack, Skeleton, Text } from "@chakra-ui/react";
import { ClaimsSummary } from "../types";

type Props = { summary?: ClaimsSummary };

const SummaryCard = ({
  label,
  value,
  caption,
}: {
  label: string;
  value?: string;
  caption?: string;
}): JSX.Element => (
  <Card.Root
    flex="1"
    borderRadius="lg"
    border="none"
    boxShadow="rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
  >
    <Card.Body p="4" gap={1}>
      <Text fontSize="sm" fontWeight={600} color="gray.700">
        {label}
      </Text>
      <Skeleton loading={value === undefined} minH="36px">
        <Text fontSize="2xl" fontWeight={700}>
          {value}
        </Text>
      </Skeleton>
      {caption && (
        <Text fontSize="sm" color="gray.600">
          {caption}
        </Text>
      )}
    </Card.Body>
  </Card.Root>
);

const SummaryCards = ({ summary }: Props): JSX.Element => {
  const formatCurrency = useNumberFormatter("es-CO", "COP", "currency");
  const dismissedRate =
    summary && summary.amount > 0
      ? Math.round((summary.dismissedAmount / summary.amount) * 100)
      : 0;

  return (
    <HStack gap={4} align="stretch" flexShrink={0}>
      <SummaryCard
        label="Valor reclamado"
        value={summary && formatCurrency(summary.amount)}
        caption={summary && `${summary.count} reclamación(es)`}
      />
      <SummaryCard
        label="Valor desistido"
        value={summary && formatCurrency(summary.dismissedAmount)}
      />
      <SummaryCard
        label="% desistimiento"
        value={summary && `${dismissedRate}%`}
        caption="desistido / reclamado"
      />
    </HStack>
  );
};

export default SummaryCards;
